<template>
    <div class="inline-block">
        <Icons.TITrue class="ml-2 items-start fill-current text-green-700" v-if="params.value === true"></Icons.TITrue>
        <Icons.TIFalse class="ml-2 items-start fill-current text-red-700" v-else-if="params.value === false"></Icons.TIFalse>
    </div>
</template>

<script setup>
import Icons from '../../Icons.js';

const params = defineProps({
    value: Boolean,
});
</script>